module.exports = "https://www.gc-pro.gnp.com.mx/b16e73e5ed103a97ccc46b19990d3d5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-13.png
// module id = 940
// module chunks = 0 1